import { useState, useEffect } from 'react';

/**
 * Hook para detectar el tamaño de la ventana del navegador
 * @returns El ancho actual de la ventana en píxeles
 */
export const useWindowSize = (): number => {
  const [windowSize, setWindowSize] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};